import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "evrideo-clipping-studio-transcript-floating-toolbar",
  templateUrl: "./clipping-studio-transcript-floating-toolbar.component.html",
  styleUrls: ["./clipping-studio-transcript-floating-toolbar.component.scss"],
})
export class ClippingStudioTranscriptFloatingToolbarComponent {
  @Input() position: { x: number; y: number } = { x: 0, y: 0 };
  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() timing = new EventEmitter<void>();
  @Output() highlight = new EventEmitter<string | undefined>();
  @Output() deleteSelection = new EventEmitter<void>();
  @Output() more = new EventEmitter<void>();

  showAddDropdown = false;
  showHighlightDropdown = false;
}
